import { GTMEventDataMapping } from '../GTM.d'
import { isItemWithKeys } from '@corratech/pylot-utils'

// For each action name, all the fields , that are defined in the configMapping,
// should be replaced in the defaultMapping (if possible).
export const combineDataMapping = (
    defaultMapping: GTMEventDataMapping,
    configMapping: GTMEventDataMapping
): GTMEventDataMapping => {
    const combinedMapping: GTMEventDataMapping = { ...defaultMapping }
    Object.keys(configMapping).forEach((actionName) => {
        // The action name should exist in the defaultMapping of a component.
        // This fact signifies that that specific handler component can process an action with that name.
        if (typeof defaultMapping[actionName] === 'undefined') {
            return
        }

        if (!isItemWithKeys(configMapping[actionName])) {
            combinedMapping[actionName] = configMapping[actionName]
            return
        }

        // Only overrides for specific fields are applied
        combinedMapping[actionName] = {
            ...defaultMapping[actionName],
            ...configMapping[actionName]
        }
    })

    return combinedMapping
}
